import React from 'react';

interface SyncStatusBarProps {
  pendingCount: number;
  syncing: boolean;
  dimmed?: boolean;
}

// Zastępuje dawny pasek tokenów na dole E1 — token quota nie jest już tu istotna,
// a użytkownik potrzebował widocznego, wiarygodnego dowodu, że synchronizacja
// offline→backend faktycznie działa (a nie tylko "powinna").
export const SyncStatusBar: React.FC<SyncStatusBarProps> = ({ pendingCount, syncing, dimmed }) => {
  const label = syncing
    ? 'Synchronizuję…'
    : pendingCount > 0
      ? `${pendingCount} do wysłania`
      : 'Zsynchronizowano';

  const color = syncing
    ? 'rgba(0,153,255,0.85)'
    : pendingCount > 0
      ? 'rgba(255,180,0,0.85)'
      : 'rgba(0,255,85,0.7)';

  return (
    <div className="relative w-full max-w-[360px] select-none mx-auto" style={{ opacity: dimmed ? 0.35 : 1, filter: dimmed ? 'grayscale(100%)' : 'none' }}>
      <div
        className="w-full h-[15px] rounded-[5px] backdrop-blur-[16px] bg-black/20 border border-white/5 shadow-[inset_1px_1px_2px_rgba(255,255,255,0.15)] relative overflow-hidden flex items-center justify-center"
      >
        <span
          className="text-[10px] font-semibold uppercase tracking-[0.2em] drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]"
          style={{ color }}
        >
          {label}
        </span>
      </div>
    </div>
  );
};
